export enum ParticipationType {
    NotParticipate = 1,
    OnSite = 2,
    Remote = 3,
}